export default [
    {
        path: "/conversation",
        name: "conversation",
        component: () => import('@/pages/Conversation/Conversation.vue'),
        meta: {
            requiresAuth: true,
            hideBot: true
        }
    },
    {
        path: "/visit-contact/:accommodationId",
        name: "visit-contact",
        component: () => import('@/pages/Conversation/VisitContactRedirect.vue'),
        meta: {
            requiresAuth: true,
            hideBot: true
        }
    },
    {
        path: "/visit-contact-host/:accommodationId",
        name: "visit-contact-host",
        component: () => import('@/pages/Conversation/VisitContactHostRedirect.vue'),
        meta: {
            requiresAuth: true,
            hideBot: true
        }
    },
    {
        path: "/admin/conversations",
        name: "admin-conversations",
        component: () => import('@/pages/Conversation/AdminConversations.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            moduleKey: 'conversations',
            hideBot: true
        }
    },

]
